<template>
  <v-layout pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Create Corporate Customer</h2>
          </v-flex>
          <v-flex xs12 pl-1>
            <h3>Business User</h3>
          </v-flex>
          <ExistingUser
            :errors="errors.user"
            @selectedUser="handleSelectedUser"
            @useExistingUserToggled="useExistingUserToggled"
            :disabled="disabled"
          />
          <v-flex xs12 md12>
            <UserForm
              ref="userForm"
              :disabled="disabled || user.use_existing"
              :user="user"
              :errors="errors.user"
              :editingUser="user.use_existing"
              @validityChange="updateFormValidity('user', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 pl-1 pt-2>
            <h3>Business Information</h3>
          </v-flex>
          <v-flex xs12 md12>
            <BusinessForm
              ref="businessForm"
              :business="business"
              :disabled="disabled"
              :paymentTypes="paymentTypesList"
              :errors="errors.business"
              @validityChange="updateFormValidity('business', $event)"
            />
            <v-divider class="mx-1"></v-divider>
          </v-flex>
          <v-flex xs12 md12>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none" :disabled="disabled">Submit</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/customer/UserForm.vue";
import ExistingUser from "@/components/driver/ExistingUser.vue";
import BusinessForm from "@/components/corporateCustomer/BusinessForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "create_corporate_customer",
  components: {
    SimpleCard,
    UserForm,
    ExistingUser,
    BusinessForm,
  },
  data: function () {
    return {
      user: {
        use_existing: false,
        name: "",
        email: "",
        contact_number: "",
        password: "",
        accounting_reference_number: "",
      },
      business: {
        address1: "",
        address2: "",
        town: "",
        county: "",
        postcode: "",
        kiosk_passcode: "",
        location: {},
        location_name: "",
        hotel: false,
        default_payment_type: "account",
        sub_accounts_enabled: false,
      },
      paymentTypes: {},
      paymentTypesList: [],
      errors: {},
      userFormValid: false,
      businessFormValid: false,
      loading: true,
      disabled: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
    };
  },
  mounted: function () {
    this.getPaymentTypes();
  },
  methods: {
    getPaymentTypes: async function () {
      try {
        let url = `${this.$store.state.apiUrl}/corporateCustomer/getPaymentTypes`;
        let response = await axios.get(url, {
          params: {},
        });

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.snackbarMessage =
            "Failed to get information to create corporate customer";
          this.snackbarColour = "error";
          this.snackbarShow = true;
        } else {
          if (response.data.paymentTypes) {
            this.paymentTypes = response.data.paymentTypes;
            this.disabled = false;
          } else {
            this.snackbarMessage =
              "Failed to get information to create corporate customer";
            this.snackbarColour = "error";
            this.snackbarShow = true;
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(
          "Failed to get information required to create corporate customer " +
            error
        );
        this.snackbarMessage =
          "Failed to get information to create corporate customer";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.loading = false;
      }
    },
    submit: async function () {
      if (this.userFormValid && this.businessFormValid) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/corporateCustomer/create`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            business: this.business,
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding corporate customer, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding corporate customer: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const driverID = response.data.driver.id;
              self.$router.push("../corporateCustomer/view/" + driverID);
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.businessForm.validateForm();
      }
    },
    handleSelectedUser: function (existingUser) {
      this.user.id = existingUser.id;
      this.user.name = existingUser.name;
      this.user.email = existingUser.email;
      this.user.contact_number = existingUser.contact_number;
      this.user.password = null;
    },
    useExistingUserToggled: function (useExisting) {
      this.user.use_existing = useExisting;
    },
    updateFormValidity: function (form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "business":
          this.businessFormValid = value;
          break;
      }
    },
  },
  watch: {
    paymentTypes: function () {
      this.paymentTypesList = [];
      for (const key in this.paymentTypes) {
        this.paymentTypesList.push({
          key: key,
          name: this.paymentTypes[key],
        });
      }
    },
  },
};
</script>